import { FormHelperText } from "@mui/material";
import { red } from "@mui/material/colors";
import React from "react";
import { useDropzone } from "react-dropzone";
import { useWatch } from "react-hook-form";
import { middleEllipsisText } from "../../../common/helpers/middleEllipsisText";
import {
  Dropzone,
  DropzoneContainer,
  DropzoneContent,
  FileHelper,
  FileLabel,
} from "../styles";

const FileDropzone = ({ type, label, name, error, control, onDrop }) => {
  const current = useWatch({ control, name });
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    accept: {
      ...(type === 1 && { "application/octet-stream": [".stl"] }),
      ...(type === 2 && {
        "image/jpeg": [".jpg", ".jpeg"],
        "image/png": [".png"],
      }),
    },
    onDropAccepted: (files) => {
      onDrop(files[0]);
    },
    onDropRejected: (error) => {
      let message = "";
      if (error[0].errors[0].code === "file-invalid-type") {
        message = "Invalid file type.";
        if (type === 1) {
          message = message + " Please choose a file with a .stl extension.";
        } else if (type === 2) {
          message = message + " Please choose a file with a .jpg, .jpeg, or .png extension";
        }
      } else {
        message = error[0].errors[0].message;
      }
      alert(message);
    },
  });

  return (
    <DropzoneContainer>
      <Dropzone
        {...getRootProps()}
        style={{ borderColor: Boolean(error) && red[300] }}
      >
        <input {...getInputProps()} />
        <DropzoneContent>
          <FileLabel>{label}</FileLabel>
          <FileHelper>
            {Boolean(current)
              ? middleEllipsisText(current.file.name)
              : "Drag or drop file"}
          </FileHelper>
        </DropzoneContent>
      </Dropzone>
      <FormHelperText error={true}>
        {Boolean(error) && error.message}
      </FormHelperText>
    </DropzoneContainer>
  );
};

export default FileDropzone;
